import { createAsyncThunk } from '@reduxjs/toolkit'
import { buildQuery } from '../../utils/buildQuery'
import { callApi } from '../../utils/callApi'
import { IChatOline } from '../chatsOnline/types'
import { ISearchChat, ISearchChatsOnlineState } from './types'

export const searchChats = createAsyncThunk<ISearchChatsOnlineState['data'], ISearchChat>(
  'searchChatsTechSupport/searchChats',
  async (payload, thunkAPI) => {
    try {
      const query = buildQuery(payload)

      return callApi({
        method: 'get',
        path: query ? `/admin-tech-support/search?${query}` : '/admin-tech-support/search',
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

export const getDialog = createAsyncThunk<ISearchChatsOnlineState['dialog'], number>(
  'searchChatsTechSupport/getDialog',
  async (payload, thunkAPI) => {
    try {
      const id = payload
      return callApi({
        method: 'get',
        path: `/admin-tech-support/dialog/chat/${id}`,
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)

export const getDialogMessages = createAsyncThunk<IChatOline, { id: number; page: number }>(
  'searchChatsTechSupport/getDialogMessages',
  async (payload, thunkAPI) => {
    try {
      const { id, page } = payload
      return callApi({
        method: 'get',
        path: page ? `/admin-tech-support/dialog/messages/${id}?page=${page}` : 'admin-tech-support/dialog/messages',
      })
    } catch (e) {
      return thunkAPI.rejectWithValue(e)
    }
  }
)
